import React from 'react';
import { DrawerNav, useDrawer } from '@thd-olt-component-react/drawer';
import { Image } from '@thd-olt-component-react/image';
import './QuickViewNav.scss';

export const QuickViewNav = () => {
  const { setPreviousDrawer } = useDrawer();

  const goBack = (event) => {
    event.preventDefault();
    setPreviousDrawer();
  };
  return (
    <div className="quickview-nav">
      <DrawerNav>
        <a
          href="/"
          onClick={goBack}
          className="quickview-nav__back"
          data-testid="quickview-nav-link"
        >
          <Image
            src="https://assets.thdstatic.com/images/v1/caret-blue.svg"
            alt="Back"
          />
          Back to Quick View
        </a>
      </DrawerNav>
    </div>
  );
};